/**
 * Tonnie's public legal pages — linked from sign-up ("By continuing, you agree
 * to Tonnie's terms") and from Settings → About & Legal.
 */
export const TONNIE_LEGAL_URLS = {
  terms: 'https://tonnie.ai/terms',
  privacy: 'https://tonnie.ai/privacy',
} as const;
